/**
 * Idempotency key generator and payload hashing.
 */

import { IDEMPOTENCY_KEY_PREFIX } from './types';

/**
 * Genera una chiave di idempotency univoca.
 * Formato: idem_{operationType}_{localEntityId}_{timestamp}_{random}
 */
export function generateIdempotencyKey(
  operationType: string,
  localEntityId: string
): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 8);
  return `${IDEMPOTENCY_KEY_PREFIX}_${operationType}_${localEntityId}_${timestamp}_${random}`;
}

/**
 * Genera hash del payload per verificare che retry abbiano stessi dati.
 */
export function hashPayload(payload: unknown): string {
  let json: string;
  if (payload !== null && typeof payload === 'object' && !Array.isArray(payload)) {
    json = JSON.stringify(payload, Object.keys(payload as Record<string, unknown>).sort());
  } else {
    json = JSON.stringify(payload);
  }
  return _simpleHash(json);
}

function _simpleHash(str: string): string {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash).toString(16);
}

export function isValidIdempotencyKey(key: string): boolean {
  return key.startsWith(`${IDEMPOTENCY_KEY_PREFIX}_`) && key.split('_').length >= 5;
}

export function parseIdempotencyKey(key: string): {
  operationType: string;
  localEntityId: string;
  timestamp: string;
  random: string;
} | null {
  const parts = key.split('_');
  if (parts.length < 5 || parts[0] !== IDEMPOTENCY_KEY_PREFIX) {
    return null;
  }
  return {
    operationType: parts[1],
    localEntityId: parts[2],
    timestamp: parts[3],
    random: parts[4],
  };
}
